export default "__VITE_ASSET__fb4ef7f8__"